import React from 'react';
import { Bar } from 'react-chartjs-2';

export default function TotalBeneficiaries({ stats }) {
  return (
    <section className={'shadow p-5 bg-white mt-5'}>
      <div className={'flex flex-col lg:flex-row justify-between'}>
        <div>
          <h3 className={'font-medium text-base lg:text-lg'}>
            Total Beneficiaries
          </h3>
        </div>
      </div>
      <div>
        <Bar
          data={{
            labels: stats && Object.keys(stats.total_beneficiaries),
            datasets: [
              {
                label: 'No. of Beneficiaries',
                data: stats && Object.values(stats.total_beneficiaries),
                backgroundColor: ['rgba(255, 159, 64, 0.2)'],
                borderColor: ['rgba(255, 159, 64, 1)'],
                borderWidth: 1,
              },
            ],
          }}
          options={{
            scales: {
              x: {
                display: true,
                title: {
                  display: true,
                  text: 'Months',
                },
              },
              y: {
                display: true,
                title: {
                  display: true,
                  text: 'No. of Beneficiaries',
                },
              },
            },
          }}
        />
      </div>
    </section>
  );
}
